import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  page: {
    width: '100vw',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    background: '#F1F3F6',
    overflow: 'hidden'
  },
  header: {
    height: 96,
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(0, 5),
    background: '#FFFFFF',
    borderBottom: '1px solid #EAECF0',
    [theme.breakpoints.down('sm')]: {
      height: 64,
      padding: theme.spacing(0, 2)
    }
  },
  logo: {
    height: 72,
    objectFit: 'contain',
    [theme.breakpoints.down('sm')]: {
      height: 40
    }
  },
  downloadButton: {
    borderRadius: 999,
    textTransform: 'none',
    fontWeight: 600,
    boxShadow: 'none'
  },
  content: {
    flex: 1,
    minHeight: 0,
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(4, 2),
    overflow: 'hidden'
  },
  documentCard: {
    width: '100%',
    maxWidth: 960,
    height: '100%',
    background: '#FFFFFF',
    borderRadius: 12,
    boxShadow: '0px 4px 16px rgba(16, 24, 40, 0.06)',
    overflow: 'hidden',
    display: 'flex'
  },
  loaderContainer: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  noticeContainer: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(2)
  },
  contact: {
    marginTop: theme.spacing(2),
    color: '#5D7083',
    fontSize: '14px'
  }
}));
